import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from "primereact/inputswitch";
import {AutoComplete} from "primereact/autocomplete";
import axios from 'axios';

const ReceiptgroupFormComponent = (props) => {

  const [formData, setFormData] = useState({
    // outgoing: true,
    external: false,
    active: true,
  });
  const [loading, setLoading] = useState(false);
  const [receipttypes, setReceipttypes] = useState([]);
  const [bankaccounts, setBankaccounts] = useState([]);
  const isCustomerType = String(formData.receiptType || '').startsWith('CUSTOMER_');
  const isSupplierType = String(formData.receiptType || '').startsWith('SUPPLIER_');
  const showPrefixAndBank = isCustomerType && !formData.external;
  const originOptions = [
    {label: props.t('receiptOriginInternal'), value: false},
    {label: props.t('receiptOriginExternal'), value: true},
  ];

  const validate = (data) => {
    let errors = {};
    if (isSupplierType && formData.external !== true) {
      errors.external = props.t('supplierReceiptOriginValidation');
    }
    if (isCustomerType && formData.external === false && !formData.prefix?.trim()) {
      errors.prefix = props.t('internalReceiptPrefixValidation');
    }
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    // if (!data.receiptType) {
    //   errors.receiptType = 'Az típus nem lehet üres';
    // }
    return errors;
  };
  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data: data,
      params: {},
      headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
    });
  }
  const onSubmit = (_, form) => {
  setLoading(true);

  const payload = {
    receipt_type: formData.receiptType,
    name: formData.name,
    prefix: formData.prefix || "",
    active: !!formData.active,
    external: !!formData.external,
    // outgoing: !!formData.outgoing,
  };

  if (formData.company?.id) {
    payload.company = formData.company.id;
  }
  if (formData.bankAccount?.id) {
    payload.bank_account = formData.bankAccount.id;
  }

  // const method = props && props.initialValues ? 'put' : 'post';
  // const url = !!formData.id ? `/api/v2/receipt-group/${formData.id}` : `/api/v2/receipt-group`;
  const isUpdate = !!formData.id; 
  const method = isUpdate ? 'put' : 'post';
  const url = isUpdate ? `/api/v2/receipt-group/${formData.id}` : `/api/v2/receipt-group`;
  apiCall(method, url, payload)
      .then(() => {
        window.App.toastShow('success', !!formData.id ? 'Sikeres módosítás!' : 'Sikeres mentés!');
        window.App.setState({
          rerenderReceiptgroupList: true,
          sidebarReceiptgroupCreate: false,
          sidebarReceiptgroupUpdate: false,
        });
        setLoading(false);
      })
      .catch(error => {
        console.error('Receiptgroup error:', error.response?.data || error);
        window.App.toastShow(
          'error',
          'Hiba történt!',
          JSON.stringify(error.response?.data ?? error.toString()),
          '',
          error.response
        );
        setLoading(false);
      });

    form.restart();
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  // company autocomplete
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(localStorage.getItem('defaultCompanyName'));

  const searchCompany = () => {
    apiCall('get', `/api/v2/company`)
      .then(response => {
        setCompanies(response.data.data?.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  useEffect(() => {
     apiCall('get', '/api/v2/bank-account')
      .then(response => {
        setBankaccounts(response.data.data?.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
     apiCall('get', '/api/v2/dictionary/receipt-type')
      .then(response => {
        const raw = response.data?.data || [];
        const transformed = raw.map(item => ({
          id: item.key,
          name: item.value,
        }));
        setReceipttypes(transformed);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
    if (props?.initialValues?.id) {
      apiCall('get', `/api/v2/receipt-group/${props.initialValues.id}`)
        .then(response => {
          const data = response.data?.data || response.data || {};
          setFormData({
            ...data,
            id: data.id,
            receiptType: data.receipt_type,
            external: String(data.receipt_type || '').startsWith('SUPPLIER_') ? true : !!data.external,
            bankAccount: data.bank_account
              ? { id: data.bank_account.id ?? data.bank_account }
              : data.bankAccount,
          });
          if (response.data?.companyName) {
            setSelectedCompany(response.data.companyName);
          } else if (data.company?.name) {
            setSelectedCompany(data.company.name);
          }
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }
  }, [])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> {props.t('tabBasicData')}
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-md-6 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col"}>
              <Field name="receiptType" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="receiptType"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldType')}</label>
                  <span className="p-d-block">
                    {formData && (!formData.counter || formData.counter === 0) ? (
                      <Dropdown options={window.App.sortDropdownOptions(receipttypes, "name")}
                                optionLabel="name"
                                optionValue="id"
                                id={"receiptType"}
                                placeholder={props.t('selectTypePlaceholder')}
                                emptyMessage={props.t('noTypeYet')}
                                onChange={(e) => {
                                  const nextType = e.value;
                                  const isSupplierType = typeof nextType === 'string' && nextType.startsWith('SUPPLIER_');
                                  setFormData(prev => ({
                                    ...prev,
                                    receiptType: e.value,
                                    external: isSupplierType ? true : prev.external,

                                  }))
                                }}
                                value={formData.receiptType}
                                showClear
                      />
                    ) : (
                      <Dropdown options={window.App.sortDropdownOptions(receipttypes, "name")}
                                optionLabel="name"
                                optionValue="id"
                                id={"receiptType"}
                                placeholder={props.t('selectTypePlaceholder')}
                                emptyMessage={props.t('noTypeYet')}
                                disabled
                                value={formData.receiptType}
                      />
                    )}
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            
            {showPrefixAndBank &&
              <div className={"p-col"}>
                <Field name="prefix" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="prefix"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPrefix')}</label>
                    <span className={"p-d-block"}>
                      {formData && (!formData.counter || formData.counter === 0) ? (
                        <InputText id="prefix" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       prefix: e.target.value
                                     })
                                   }}
                                   value={formData.prefix}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      ) : (
                        <InputText id="prefix" {...input}
                                   disabled
                                   value={formData.prefix}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      )}
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }

            {formData && formData.external === false &&
              <div className={"p-col-12 p-lg-6"}>
                <Field name="company" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="company"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompanyLegalEntity')}</label>
                    <span className={"p-d-block"}>
                    {localStorage.getItem('roles').toString().includes('role_company_browse')
                    || localStorage.getItem('roles').toString().includes('role_company_read') ? (
                      <>
                        {formData && formData.counter && formData.counter > 0 && formData.companyName !== null ? (
                          <AutoComplete value={selectedCompany}
                                        disabled
                                        forceSelection
                                        id={"company"}
                                        suggestions={companies}
                                        completeMethod={searchCompany}
                                        field={"name"}
                                        delay="1000"
                                        placeholder={props.t('typeToSearchPlaceholder')}
                                        className={classNames({'p-invalid': isFormFieldValid(meta)})}

                          />
                        ) : (
                          <AutoComplete value={selectedCompany}
                                        id={"company"}
                                        suggestions={companies}
                                        completeMethod={searchCompany}
                                        field={"name"}
                                        delay="1000"
                                        forceSelection
                                        placeholder={props.t('typeToSearchPlaceholder')}
                                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                        onSelect={(e) => {
                                          setFormData({
                                            ...formData,
                                            company: {id: e.value.id}
                                          })
                                        }}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            company: {id: null}
                                          })
                                          setSelectedCompany(e.value)
                                        }}
                                        dropdown
                                        onClear={(e) => {
                                          setSelectedCompany('')
                                        }}
                          />
                        )}
                      </>
                    ) : (
                      <Dropdown disabled className={"disabled"} id={"company"} showClear/>
                    )}
                  </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            }
            {showPrefixAndBank && (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="bankAccount" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="vat"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDefaultBankAccount')}</label>
                    <span className={"p-d-block"}>
                            {formData && formData.bankAccount && formData.bankAccount.id ? (
                              <Dropdown {...input}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            bankAccount: {id: e.value}
                                          })
                                        }}
                                        value={formData.bankAccount.id}
                                        options={window.App.sortDropdownOptions(bankaccounts, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"bankAccount"}
                                        emptyMessage={props.t('noBankAccountYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            ) : (
                              <Dropdown {...input}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            bankAccount: {id: e.value}
                                          })
                                        }}
                                        options={window.App.sortDropdownOptions(bankaccounts, "name")}
                                        optionLabel="name"
                                        optionValue="id"
                                        id={"bankAccount"}
                                        emptyMessage={props.t('noBankAccountYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            )}
                          </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
          </div>
          <div className={"p-grid p-mt-1"}>
            {/* <div className={"p-col-12 p-md-6 p-lg-6"}>
              <Field name="outgoing" render={({input, meta}) => (
                <div className="p-grid p-pt-2">
                  <div className={"p-col-6 p-lg-2 p-xl-2"}>
                    {formData && (!formData.counter || formData.counter === 0) ? (
                      <InputSwitch
                        className={"p-mt-1"}
                        checked={formData.outgoing}
                        value={formData.outgoing}
                        onChange={e => setFormData({...formData, outgoing: e.value})}/>
                      ):(
                      <InputSwitch
                        className={"p-mt-1 disabled"}
                        checked={formData.outgoing}
                        value={formData.outgoing}
                        disaled />
                      )}
                  </div>
                  <div className={"p-col-6 p-lg-10 p-xl-10 p-col-align-center"}>
                    <label htmlFor="outgoing"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldOutgoing')}</label>
                  </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}
            {!!formData.receiptType && (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="external" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="external"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('receiptOrigin')}</label>
                    <Dropdown
                      id="external"
                      options={originOptions}
                      value={formData.external}
                      disabled={isSupplierType || !!formData.counter}
                      onChange={e => setFormData({...formData, external: e.value})}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                    {isSupplierType && <small className="p-d-block p-mt-1">{props.t('supplierReceiptOriginHelp')}</small>}
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            <div className={"p-col-12 p-md-6 p-lg-6"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-grid p-pt-2">
                  <div className={"p-col-6 p-lg-2 p-xl-2"}>
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.active}
                      value={formData.active}
                      onChange={e => setFormData({...formData, active: e.value})}/>
                  </div>
                  <div className={"p-col-6 p-lg-10 p-xl-10 p-col-align-center"}>
                    <label htmlFor="active"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label={props.t('save')} icon={"pi pi-check"} loading={loading}
                      className="p-button-success"/>
            </div>
          </div>
        </Panel>
      </form>
    )}/>
  )
}
export default withTranslation('common')(ReceiptgroupFormComponent);
